import Axios from "axios";
import config from "./config";
import {
  userClient,
  paymentClient,
  adminClient,
  adminV1Client,
  feedClient,
  followClient,
  baseClient,
  rootClient
} from './apiClient';

/**
 * @deprecated Use specialized clients from ./apiClient instead.
 * This file is maintained for backward compatibility.
 */

const getClient = (version) => {
  switch (version) {
    case config.SERVICES.USER: return userClient;
    case config.SERVICES.PAYMENT: return paymentClient;
    case config.SERVICES.ADMIN: return adminClient;
    case config.SERVICES.ADMIN_V1: return adminV1Client;
    case config.SERVICES.FEED: return feedClient;
    case config.SERVICES.FOLLOW: return followClient;
    case config.SERVICES.BASE: return baseClient;
    case config.SERVICES.ROOT:
    case "":
    case undefined:
      return rootClient;
    default:
      // Fallback for any other strings passed as version
      return rootClient;
  }
};

export const getApi = async (action, version = config.VERSION) => {
  try {
    return await getClient(version).get(action);
  } catch (error) {
    // Return error data for backward compatibility if it exists
    return error.data || error;
  }
};

export const postApi = async (action, data, ip, version = config.VERSION) => {
  try {
    const options = ip ? { headers: { ipAddress: ip } } : {};
    return await getClient(version).post(action, data, options);
  } catch (error) {
    return error.data || error;
  }
};

export const putApi = async (action, data, ip, version = config.VERSION) => {
  try {
    const options = ip ? { headers: { ipAddress: ip } } : {};
    return await getClient(version).put(action, data, options);
  } catch (error) {
    return error.data || error;
  }
};

export const patchApi = async (action, data, ip, version = config.VERSION) => {
  try {
    const options = ip ? { headers: { ipAddress: ip } } : {};
    return await getClient(version).patch(action, data, options);
  } catch (error) {
    return error.data || error;
  }
};

export const deleteApi = async (action, version = config.VERSION) => {
  try {
    return await getClient(version).delete(action);
  } catch (error) {
    return error.data || error;
  }
};

export const postFormData = async (action, formData, version = config.VERSION) => {
  try {
    return await getClient(version).post(action, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    return error.data || error;
  }
};

// Internal refresh token call for specific needs
export const postRefreshToken = async () => {
  // Logic is now handled automatically by interceptors in apiClient.js
  // But we can still expose it if needed
  try {
    const response = await adminV1Client.post('/refresh-token', {
      refresh_token: localStorage.getItem("refresh_token")
    });
    return response.success;
  } catch (e) {
    return false;
  }
};

export const getExternalApi = async (action) => {
  try {
    const response = await Axios.get(action);
    return {
      status: response.status === 200,
      data: response.data,
      message: response.data?.message
    };
  } catch (error) {
    return error.response?.data || error;
  }
};

export const cancelRequest = () => {
  console.warn("cancelRequest is deprecated and not supported in the new multi-client architecture. Use individual AbortControllers instead.");
};